import React from "react"

import WithObject from "data/wrappers/WithObject"
import withContext from "../../../withContext"
import { Dropdown } from "ui"

export default withContext(({ context, ...props }) => (
    <WithObject objectId={context.block.config.attributes.objectId}>
        {({ object }) => {
            const value = props.value || {}

            return (
                <div className="display-flex">
                    <div style={{ flex: 1 }}>
                        <Dropdown
                            options={object.fields.map(field => ({
                                value: field.api_name,
                                label: field.label,
                            }))}
                            value={value.id}
                            onChange={id => props.onChange({ ...value, id })}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <Dropdown
                            options={[
                                { label: "ASC", value: "false" },
                                { label: "DESC", value: "true" },
                            ]}
                            value={value.desc ? "true" : "false"}
                            onChange={desc => props.onChange({ ...value, desc: desc === "true" })}
                        />
                    </div>
                </div>
            )
        }}
    </WithObject>
))



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/form/objectOrder.js